import { useState, useEffect } from "react";
import { doRequest } from "../utils/helper";
import { addGlobalFont } from "polotno/config";


export const useFontLoader = () => {
  const [teedexFontsList, setTeedexFontsList] = useState([]);
  const [ownFontsList, setOwnFontsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fontsLoaded, setFontsLoaded] = useState(false);
  const [fontsJson, setFontsJson] = useState([]);

  const getfontsList = async () => {
    try {
      setLoading(true);
      const response = await doRequest("", "GET", "font/list");
      if (+response?.resultFlag === 1) {
        let fonts = response?.response?.font;
        const teedex = fonts.filter((i) => i.uploaded_role === "admin");
        const own = fonts.filter((i) => i.uploaded_role === "user");
        setTeedexFontsList(teedex);
        setOwnFontsList(own);
        await loadFonts(fonts); // Load fonts dynamically
        setFontsLoaded(true);
        setLoading(false);
      } else {
        setLoading(false);
        setTeedexFontsList([]);
        setOwnFontsList([]);
        console.error(response?.message ? response?.message : "Something went wrong");
      }
    } catch (error) {
      setLoading(false);
      console.error(error?.message ? error?.message : "Something went wrong!");
    }
  };

  const loadFonts = async (fontsFromApi) => {
    setLoading(true);

    let fontsList = []; 

    const loadPromises = fontsFromApi.map((font) => {
      const url = font.url.startsWith("http") ? font.url : `/${font.url}`;
      // console.log("Trying to load font:", font.name, "→", url);

      const fontFace = new FontFace(font.name, `url('${url}')`);

      // adding global fonts
      addGlobalFont({
        fontFamily: font.name,
        url: `${font.url}`,
      });
      // console.log("now added global font: ", font.name, " url: ", font.url);
      fontsList.push({
        fontFamily: font.name,
        url: font.url,
      });
      // end


      const loadPromise = fontFace
        .load()
        .then((loadedFont) => {
          document.fonts.add(loadedFont);
          // console.log("Font loaded test3333:", font.name);
        })
        .catch((error) => {
          console.error("❌ Failed to load font:", font.name, error);
        });

      // Inject @font-face
      const format = url.endsWith(".otf")
        ? "opentype"
        : url.endsWith(".ttf")
          ? "truetype"
          : url.endsWith(".woff2")
            ? "woff2"
            : url.endsWith(".woff")
              ? "woff"
              : "";
      const style = document.createElement("style");
      style.innerHTML = `
      @font-face {
        font-family: '${font.name}';
        src: url('${url}') format('${format}');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
    `;
      document.head.appendChild(style);



      return loadPromise;
    });

    setFontsJson([...fontsList]);
    // console.log("total fonts ", fontsList.length); 
    await Promise.all(loadPromises);
    setLoading(false);
  };

  useEffect(() => {
    getfontsList();
  }, []);

  return {
    teedexFontsList,
    ownFontsList,
    loading,
    fontsLoaded,
    getfontsList,
    loadFonts,
    fontsJson
  };
}; 